const SERVER_URI = 'http://localhost:3000';
/**
 * Application context related configs.
 */
const PSA_API_PROFILE = 'realtor-search';
const APP_CONTEXT_CLIENT_KEY_HEADER = 'Client-key';
const APP_CLIENT_KEY = 'is24-realtor-search';
const APP_CONTEXT_REQUEST_OPTS = {
  headers: {
    [APP_CONTEXT_CLIENT_KEY_HEADER]: APP_CLIENT_KEY,
    Accept: 'application/json',
  },
};

export {
  SERVER_URI,
  PSA_API_PROFILE,
  APP_CONTEXT_CLIENT_KEY_HEADER,
  APP_CLIENT_KEY,
  APP_CONTEXT_REQUEST_OPTS,
};
